import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck } = FiIcons;

const WordList = ({ words, foundWords }) => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-6 border border-gray-200">
      <h2 className="text-xl font-semibold text-[#2b6777] mb-4 font-rubik">
        Zu findende Wörter
      </h2>
      
      <div className="mb-4">
        <div className="bg-gray-200 rounded-full h-2">
          <div 
            className="bg-green-500 rounded-full h-2 transition-all duration-300"
            style={{ width: `${(foundWords.length / words.length) * 100}%` }}
          />
        </div>
        <p className="text-sm text-[#2b6777] mt-2 font-rubik opacity-80">
          {foundWords.length} von {words.length} gefunden
        </p>
      </div>

      <div className="space-y-2">
        {words.map((word, index) => {
          const isFound = foundWords.includes(word);
          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              className={`
                flex items-center gap-3 p-3 rounded-lg transition-all duration-200
                ${isFound 
                  ? 'bg-green-50 text-green-800 border border-green-200' 
                  : 'bg-gray-50 text-[#2b6777] border border-gray-200'
                }
              `}
            >
              <div className={`
                w-6 h-6 rounded-full flex items-center justify-center
                ${isFound ? 'bg-green-500' : 'bg-gray-300'}
              `}>
                {isFound && (
                  <SafeIcon icon={FiCheck} className="text-white text-sm" />
                )}
              </div>
              <span className={`
                font-medium font-rubik
                ${isFound ? 'line-through' : ''}
              `}>
                {word}
              </span>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default WordList;